module.exports = __webpack_public_path__ + "img/gas_valve.10981051.svg";